// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__nIeVB","text":"style_text__1vk06","subText":"style_subText__2i8X2"};